module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogProductsRecommended":{"heading":"Vybráno pro vás"}},"de":{"CatalogProductsRecommended":{"heading":"Für Sie ausgewählt"}},"sk":{"CatalogProductsRecommended":{"heading":"Vybrané pre vás"}}}')
  delete Component.options._Ctor
}
